import { BrandingStore, OrgSamlIdpStore, OrgSettingsStore, OrgStore } from "src/store";

import { createSerializer } from "./serializer";

const OrgSerializer = createSerializer({
  store: OrgStore,
  storeMap: {
    branding: BrandingStore,
    orgsettings: OrgSettingsStore,
    org_saml_idp: OrgSamlIdpStore,
  },
});

export { OrgSerializer };
